import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function IncludesSection() {
  const items = ['El protocolo completo de 14 días (15–20 min/día)', 'Ejercicios guiados (Hecho/Historia/Castigo)', 'Semáforo emocional (para no decidir en rojo)', 'Lista anti-amnesia (para no regresar por culpa)', 'Plantillas de límites (“Si pasa X, entonces yo Y”)', '25 respuestas cortas estilo México para cortar discusiones sin justificarte', 'Guía: si te quedas (condiciones mínimas) / si te vas (plan anti-regreso por culpa)'];
  return <section className="bg-white px-6 py-16 md:py-24" data-id="element-75">
      <div className="mx-auto max-w-3xl" data-id="element-76">
        <h2 className="mb-10 text-center text-3xl font-bold text-[#2D2420] md:text-4xl" data-id="element-77">
          Qué incluye{' '}
          <span className="text-[#C4704B]" data-id="element-78">(contenido real, accionable)</span>
        </h2>

        <div className="rounded-2xl bg-[#FFFBF5] p-8 ring-1 ring-[#E8DDD4] md:p-12" data-id="element-79">
          <ul className="space-y-6" data-id="element-80">
            {items.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-81">
                <CheckCircle2 className="mt-1 h-6 w-6 shrink-0 text-[#C4704B]" data-id="element-82" />
                <span className="text-lg text-[#2D2420]" data-id="element-83">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}